import { useProfile } from '@/api/queries/useProfile';

/**
 * Every lead is attributed to the submitter's HubSpot contact, so a member a
 * partner_admin never activated for sales cannot create one. Entry points gate
 * on this: the wizard's last step books a REAL Calendly appointment, and the
 * backend verifies that booking BEFORE it checks the acquirer — without the gate
 * the user would burn a genuine slot only to be refused afterwards.
 */
export function useIsSalesActivated(): boolean {
  const { data: me } = useProfile();
  return Boolean(me?.hubspotContactId);
}
